import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(Backend) // Load translations from public/locales
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Bind i18next to React
    .init({
        fallbackLng: "en",
        supportedLngs: ["en", "kh"],
        ns:['translation'],
        debug: false,
        interpolation: {
            escapeValue: false, // React already protects against XSS
        },
    });

export default i18n;
